export * from './directives/file-select.directive';
export * from './directives/file-drop.directive';
export * from './classes/file-uploader.class';

import { FileSelectDirective } from './directives/file-select.directive';
import { FileDropDirective } from './directives/file-drop.directive';

export const FILE_UPLOAD_DIRECTIVES: [any, any] = [FileSelectDirective, FileDropDirective];

export default {
  directives: [
    FILE_UPLOAD_DIRECTIVES
  ]
};



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/fileUpload/index.ts